// extracted by mini-css-extract-plugin
module.exports = {"contents":"BaseUpsellStep_contents__g2d9s","logo":"BaseUpsellStep_logo__8EgJF","heading":"BaseUpsellStep_heading___i9WN"};